export * from "-!../../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ru.vue?vue&type=template&id=5d295a12"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/ru.vue?vue&type=template&id=5d295a12
// module id = es4l
// module chunks = 0